import React from 'react';
import { H3, IconSpinner, LayoutSingleColumn, Page } from '../../components';
import FooterContainer from '../FooterContainer/FooterContainer';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useSelector } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useIntl } from 'react-intl';
import css from './SubscriptionPage.module.css';
import SubscriptionCard from './SubscriptionCard/SubscriptionCard';
import { userSelector } from '../../ducks/user.duck';
import CategoriesList from './CategoriesList';

const SubscriptionPage = () => {
  const intl = useIntl();
  const location = useLocation();

  const {
    retrieveSubscriptionPriceError,
    retrieveSubscriptionPriceInProgress,
    subscriptionPrices,
  } = useSelector(state => state.stripe);
  const currentUser = useSelector(userSelector);
  const scrollingDisabled = useSelector(isScrollingDisabled);
  const schemaTitle = intl.formatMessage({
    id: 'SubscriptionPage.schemaTitle',
  });

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'SubscriptionPage',
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        {' '}
        <div className={css.stripeSubscriptionPage}>
          <div className={css.stripeSubscriptionHead}>
            <span>{intl.formatMessage({ id: 'StripeSubscriptionPage.pricing' })}</span>
            <H3 as="h1">{intl.formatMessage({ id: 'StripeSubscriptionPage.pageTitle' })}</H3>
            {/* <p>{intl.formatMessage({ id: 'StripeSubscriptionPage.header' })}</p> */}
          </div>
          {retrieveSubscriptionPriceInProgress ? (
            <div className={css.subscriptionLoader}>
              <IconSpinner />
            </div>
          ) : (
            <div className={css.content}>
              <SubscriptionCard
                currentUser={currentUser}
                retrieveSubscriptionPriceInProgress={retrieveSubscriptionPriceInProgress}
                retrieveSubscriptionPriceError={retrieveSubscriptionPriceError}
                subscriptionPrices={subscriptionPrices}
                location={location}
              />
              <CategoriesList />
            </div>
          )}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default SubscriptionPage;
